import {AllPayeesDocument} from '@transactions/graphql';
import type {DataProxy} from '@apollo/client';
import type { AllPayeesQuery} from '@transactions/graphql';

export const addPayee = (store: DataProxy, payee: string) => {
  const data = store.readQuery<AllPayeesQuery>({query: AllPayeesDocument});
  const payees: string[] = data?.allPayees || [];

  if (!payees.find((p) => p === payee)) {
    store.writeQuery({
      query: AllPayeesDocument,
      data: {
        allPayees: [...payees, payee],
      },
    });
  }
};
